import React, { useState } from 'react';
import { createLocation } from '../../services/locationService';
import { toast } from 'react-toastify';
import styles from './Location.module.css';

/**
 * LocationForm Component / Container componant
 * A form for creating a new location by providing a name and description.
 * On successful submission, it displays a success message and clears the form fields.
 * If there's an error, an appropriate error message is displayed.
 */
const LocationForm = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [qrToken, setQrToken] = useState('');

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('qrToken');
    if (token) {
        setQrToken(token);
    }
  }, []);

  /**
   * Handle form submission
   * @param {Object} e - Event object from the form submission.
   * Prevents the default behavior, sends the location data to the server,
   * and updates the status message based on the response.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await createLocation({ name, description, qrToken });
      if (response.success) {
        toast.success('Container created successfully');
        setName('');
        setDescription('');
      } else {
        toast.error('Failed to create container');
      }
    } catch (error) {
      toast.error('Error while creating container');
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Create New Container</h2>
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.formGroup}>
          <label htmlFor="name">Name</label>
          <input
            id="name"
            className={styles.input}
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            className={styles.input}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>

        {qrToken && (
          <div className={styles.formGroup}>
            <label>Linked QR Token</label>
            <input
              className={styles.input}
              type="text"
              value={qrToken}
              readOnly
              style={{ backgroundColor: '#f1f5f9', fontWeight: 'bold' }}
            />
            <small style={{ color: '#64748b' }}>This container will be linked to the scanned QR code.</small>
          </div>
        )}

        <button className={styles.submitButton} type="submit">Submit</button>
      </form>
    </div>
  );
};

export default LocationForm;
